export default __webpack_public_path__ + "static/media/stadium-bg-ar-team.420efe66.svg";